// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThankYou_thankYou__6gi02 {
  text-align: center;
  padding: 2rem;
}
.ThankYou_thankYou__actions__kPSw- {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.ThankYou_thankYou__button__\\+M3Ho {
  background: linear-gradient(to right, #2f3c7e, #3F78B0);
  color: #ffffff;
  border: none;
  padding: 0.6rem 2.6rem;
  font-size: 0.9rem;
  font-weight: 400;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.ThankYou_thankYou__button__\\+M3Ho:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(63, 120, 176, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/BookingPage/Step/ThankYou/ThankYou.module.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,aAAA;AAHF;AAaE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,uDAAA;EACA,cAtBU;EAuBV,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;AAZJ;AAcI;EACE,2BAAA;EACA,8CAAA;AAZN","sourcesContent":["$primary-color: #3F78B0;\n$primary-color-dark: #2f3c7e;\n$white-color: #ffffff;\n\n.thankYou {\n  text-align: center;\n  padding: 2rem;\n\n//   &__title {\n//     // Estilos si son necesarios, MUI se encarga de la mayoría\n//   }\n\n//   &__message {\n//     // Estilos si son necesarios\n//   }\n\n  &__actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;\n  }\n\n  &__button {\n    background: linear-gradient(to right, $primary-color-dark, $primary-color);\n    color: $white-color;\n    border: none;\n    padding: 0.6rem 2.6rem;\n    font-size: 0.9rem;\n    font-weight: 400;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba($primary-color, 0.3);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"thankYou": `ThankYou_thankYou__6gi02`,
	"thankYou__actions": `ThankYou_thankYou__actions__kPSw-`,
	"thankYou__button": `ThankYou_thankYou__button__+M3Ho`
};
export default ___CSS_LOADER_EXPORT___;
